// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4715":"8a41c0b1","9668":"9ec74b0c"}[chunkId] + ".chunk.css";
};